/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import {Card2} from './Card2'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {fetchData, fetchFormData, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'

export default function AdminPage() {
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(12)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayAdminList, setDisplayAdminList] = useState([])

  const [pageNumbersList, setPageNumberList] = useState([1])
  const [customerData, setCustomerData] = useState(Object)

  const [showPopup, setShowPopup] = useState(false)
  const [adminId, setAdminId] = useState('')
  const [adminList, setAdminList] = useState([])

  const currentDate = new Date()
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  currentDate.setFullYear(currentDate.getFullYear() - 16)

  const onPageChange = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = adminList.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
        } else {
          tolimi = pageId * limit + limit
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = adminList.slice(tmp, tolimi)

      setDisplayAdminList(tmpdata)
    }
  }

  const adminlistapi = async () => {
    var tmp: any = sessionStorage.getItem('admin')
    tmp = JSON.parse(tmp)
    var param: any = {
      adminId: tmp['adminId'],
    }

    var response: any = await fetchData('admin/adminList', param)

    if (response.status == '200') {
      setAdminList(response.data)
      var tmp: any = response.data.slice(offset, offset + limit)
      setDisplayAdminList(tmp)
    } else {
      toasterrormsg(response.message)
    }
  }

  const deleteadmin = async (adminId: any, fullName: any) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want To Delete ' + fullName + ' Admin!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var tmp: any = sessionStorage.getItem('admin')
        tmp = JSON.parse(tmp)

        try {
          var param: any = {
            adminId: String(adminId),
            deleteBy: tmp['adminId'],
          }

          const response = await fetchData('admin/deleteAdmin', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            adminlistapi()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  const setpopupfromcard = async (id: any, type: any, fullName: any = '') => {
    if (type == 'edit') {
      setAdminId(id)
      setShowPopup(true)
    } else {
      deleteadmin(id, fullName)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Admin'
    var store: any = sessionStorage.getItem('admin')
    store = JSON.parse(store)
    setCustomerData(store)
    adminlistapi()
  }, [])

  const Popup = (props: any) => {
    // add / edit facility states
    var customer: any = sessionStorage.getItem('admin')
    customer = JSON.parse(customer)
    const [fullName, setFullName] = useState('')
    const [mobileNumber, setMobileNumber] = useState('')

    const [countryCode, setCountryCode] = useState(null)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [address, setAddress] = useState('')
    const [passwordDisplay, setPasswordDisplay] = useState(false)
    const [error, setError] = useState(Object)
    const [image, setImage] = useState()
    const [imageUrl, setImageUrl] = useState('')
    const [finalMobile, setFinalMobile] = useState('')

    useEffect(() => {
      if (adminId > '0') {
        admindetail()
      }
    }, [])

    // add/edit admin api call
    const saveAdmin = async () => {
      var img: any = image
      let param = new FormData()
      param.append('fullName', fullName)
      param.append('email', email)
      param.append('mobileNumber', mobileNumber)
      param.append('password', password)
      param.append('countryCode', String(countryCode))

      param.append('createdBy', customerData['adminId'])

      if (props.adminid > 0) {
        param.append('adminId', props.adminid)
      }
      if (img != '' && img != null && img != undefined) {
        param.append('profilePicture', img)
      }

      var res: any = await fetchFormData('admin/addEditAdmin', param)
      if (res.status == '200') {
        if (props.adminid > 0) {
          toastsuccessmsg('Admin Updated Successfully')
        } else {
          toastsuccessmsg('Admin Added Successfully')
        }

        props.onHide()
        adminlistapi()
      } else {
        toasterrormsg(res.message)
      }
    }

    // admin detail api call
    const admindetail = async () => {
      var param: any = {
        adminId: String(props.adminid),
      }
      var res = await fetchData('admin/viewProfile', param)
      if (res.status == '200') {
        var data = res.data[0]
        setFullName(data['fullName'])
        setEmail(data['email'])
        setMobileNumber(data['mobileNumber'])
        setImageUrl(data['profilePicture'])
        setCountryCode(data['countryCode'])
        setFinalMobile(data['countryCode'] + data['mobileNumber'])
      } else {
        toasterrormsg(res.message)
      }
    }

    //validation
    const validation = async () => {
      var errorMessage = {
        nameError: '',
        mobileError: '',
        emailError: '',
        passwordError: '',
        roleIdError: '',
        addressError: '',
        imageError: '',
      }
      var err = 0
      if (fullName.trim() === '' || fullName.trim() === null || fullName.trim() === undefined) {
        errorMessage['nameError'] = 'Admin Name Required'
        err = 1
      } else if (!fullName.trim().match(/^[a-zA-Z\s]+$/) || fullName.trim().length > 100) {
        errorMessage['nameError'] = 'Enter Valid Admin Name'
        err = 1
      }

      if (mobileNumber === '' || mobileNumber === null || mobileNumber === undefined) {
        errorMessage['mobileError'] = 'Admin Mobile Number Required'
        err = 1
      }

      if (!mobileNumber.match(/^\d+$/) || mobileNumber.length > 16 || mobileNumber.length < 6) {
        errorMessage['mobileError'] = 'Enter Valid Mobile Number'
        err = 1
      }

      if (email === '' || email === null || email === undefined) {
        errorMessage['emailError'] = 'Admin Email Required'
        err = 1
      }

      if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
        errorMessage['emailError'] = 'Enter Valid Email'
        err = 1
      }

      if (props.adminid <= 0 && (password === '' || password === null || password === undefined)) {
        errorMessage['passwordError'] = 'Admin password Required'
        err = 1
      } else if (props.adminid <= 0 && !passwordRegex.test(password)) {
        errorMessage['passwordError'] =
          'Password must be at least 8 characters long and contain at least one alphabet, one number, and one special character'
        err = 1
      }
      if (
        (image == null || image == undefined) &&
        (imageUrl == '' || imageUrl == null || imageUrl == undefined)
      ) {
        errorMessage['imageError'] = 'Profile Picture Required'
        err = 1
      }

      setError(errorMessage)
      if (err == 0) {
        saveAdmin()
      }
    }

    // for split mobile number and country code
    const handleChange = (value: any, country: any, e: any, formate: any) => {
      const parts = formate.split(' ')
      const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
      setCountryCode(country.dialCode) // get country code
      setMobileNumber(formattedValue) // get mobile number without country code
      setFinalMobile(value)
    }

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>{adminId > '0' ? 'Edit' : 'Add'} Admin</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            {/* <!--begin::Input group--> */}
            <div className='row'>
              <div className='mx-auto mw-600px w-100' id='kt_create_account_form'>
                {/* <!--begin::Image input--> */}
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  Profile Picture
                </label>
                <div>
                  <div className='image-input image-input-outline ' data-kt-image-input='true'>
                    {/* <!--begin::Preview existing avatar--> */}

                    <img
                      id='previewImage'
                      alt='imagepreview'
                      className='image-input-wrapper w-125px h-125px changeimg pointer'
                      src={
                        image
                          ? URL.createObjectURL(image)
                          : imageUrl === undefined || imageUrl === '' || imageUrl === null
                          ? toAbsoluteUrl('/media/default.jpg')
                          : imageUrl
                      }
                    />

                    {/* <!--end::Preview existing avatar--> */}
                    {/* <!--begin::Label--> */}
                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      title=''
                      data-bs-original-title='Change avatar'
                    >
                      <i className='fa fa-edit'></i>
                      {/* <!--begin::Inputs--> */}
                      <input
                        type='file'
                        name='image'
                        id='profileImage'
                        accept='.png, .jpg, .jpeg'
                        style={{display: 'none'}}
                        onChange={(e: any) => {
                          if (
                            e.target.files[0]['type'] != 'image/jpeg' &&
                            e.target.files[0]['type'] != 'image/jpg' &&
                            e.target.files[0]['type'] != 'image/png'
                          ) {
                            alert('Upload Only JPG, PNG Or PNG File')
                          } else if (e.target.files[0] != null && e.target.files[0] != undefined) {
                            setImage(e.target.files[0])
                          }
                        }}
                      />
                      <input type='hidden' name='avatar_remove' />
                      {/* <!--end::Inputs--> */}
                    </label>
                    {/* <!--end::Label--> */}
                  </div>
                </div>
                {/* <!--end::Image input--> */}
                {/* <!--begin::Hint--> */}
                <div className='form-text' id='validimage'>
                  Allowed file types: png, jpg, jpeg.
                </div>
                <label className='text-danger'>{error['imageError'] || ''}</label>
                {/* <!--end::Hint--> */}
              </div>
              {/* <!--end::Col--> */}
            </div>
            {/* <!--end::Input group--> */}

            <div className='mx-auto mw-600px w-100 py-5' id='kt_create_account_form'>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Full Name</label>
                <input
                  type='text'
                  name='rolename'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Full Name'
                  value={fullName}
                  onChange={(e: any) => setFullName(e.target.value)}
                ></input>
                <label className='text-danger'>{error['nameError'] || ''}</label>
              </div>

              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Email</label>
                <input
                  type='text'
                  name='rolename'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Email'
                  value={email}
                  onChange={(e: any) => setEmail(e.target.value)}
                ></input>
                <label className='text-danger'>{error['emailError'] || ''}</label>
              </div>

              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  Mobile Number
                </label>
                <div className='d-lg-flex justify-content-center'>
                  <PhoneInput
                    inputClass='form-control form-control-solid w-100'
                    placeholder='Enter Mobile Number'
                    enableSearch={true}
                    value={finalMobile}
                    onChange={handleChange}
                  />
                </div>
                <label className='text-danger w-100'>{error['mobileError'] || ''}</label>
              </div>
              {customer.type == 'Customer' && (
                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Address</label>
                  <input
                    type='text'
                    name='rolename'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Address'
                    value={address}
                    onChange={(e: any) => setAddress(e.target.value)}
                  ></input>
                  <label className='text-danger'>{error['addressError'] || ''}</label>
                </div>
              )}

              {props.adminid <= 0 && (
                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Password</label>

                  <div
                    className='col-lg-12 fv-row fv-plugins-icon-container'
                    style={{position: 'relative'}}
                  >
                    <input
                      type={passwordDisplay == false ? 'password' : 'text'}
                      name='password'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder=' Password'
                      value={password}
                      onChange={(e: any) => setPassword(e.target.value)}
                    />
                    <span
                      className='cursor-pointer'
                      style={{position: 'absolute', top: '25%', right: '20px'}}
                      title={passwordDisplay == true ? 'Hide' : 'Show'}
                      onClick={() => setPasswordDisplay(!passwordDisplay)}
                    >
                      <FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} />
                    </span>
                    <div className='fv-plugins-message-container invalid-feedback'></div>
                  </div>
                  <label className='text-danger'>{error['passwordError'] || ''}</label>
                </div>
              )}

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-primary me-3`}
                  onClick={props.onHide}
                >
                  Cancel
                </button>

                <button
                  type='button'
                  className={`btn btn-lg btn-primary me-3`}
                  onClick={() => validation()}
                >
                  <span className='indicator-label'>Save</span>
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </button>
              </div>
              {/* action button end */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  return (
    <>
      <ToastContainer />
      {adminList.length > 0 ? (
        <>
          <div className='d-flex flex-wrap justify-content-between mb-6'>
            <h3 className='fw-bolder my-2'>Admin</h3>

            <div className='d-flex align-items-center'>
              <div>
                <span className='btn btn-primary py-2' onClick={() => setShowPopup(true)}>
                  +Add Admin
                </span>
              </div>
            </div>
          </div>
          <div className='container-fluid flex'>
            <div className='row mt-5'>
              {displayAdminList.map((item: any) => {
                return (
                  <Card2
                    setpopupfromcard={setpopupfromcard}
                    adminId={item.adminId}
                    profilePicture={item.profilePicture}
                    fullName={item.fullName}
                    email={item.email}
                    mobileNumber={item.mobileNumber}
                    countryCode={item.countryCode}
                  />
                )
              })}
            </div>
          </div>

          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>
              Showing {from} to {to} of {adminList.length} entries
            </div>

            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => onPageChange(page - 1)}
                >
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any) => {
                return (
                  <li className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}>
                    <span className='page-link' onClick={() => onPageChange(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => (page + 1 <= totalPage ? onPageChange(page + 1) : '')}
                >
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className='text-center px-4 my-10 py-20'>
            <p className='text-gray-400 fs-4 fw-semibold mb-10'>There are no Admin</p>
            <Link
              to='#'
              className='btn btn-primary'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_create_account'
              onClick={() => setShowPopup(true)}
            >
              Add Admin
            </Link>
            <br />
          </div>
          <div className='d-flex justify-content-center'>
            <img
              className='mw-100 mh-300px'
              alt=''
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
            />
          </div>
        </>
      )}
      {showPopup && (
        <Popup
          show={showPopup}
          onHide={() => {
            setShowPopup(false)
            setAdminId('')
          }}
          adminid={adminId}
        />
      )}
    </>
  )
}
